<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        冷配车辆管理
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            plain
            @click="updateColdVehicleInfo"
            >更新冷配车辆信息</el-button
          >
          <el-button
            class="g-form-section-search operate__item"
            title="导入"
            icon="e6-icon-Import_fill"
            @click="openImport"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="bookingDate">
            <el-date-picker
              v-model="slotForms.forms.bookingDate"
              type="year"
              format="yyyy"
              value-format="yyyy"
              placeholder="选择年"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.vehicleNum">
            <el-input
              v-model="slotForms.forms.vehicleNum"
              placeholder="车牌号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.companyName">
            <el-input
              v-model="slotForms.forms.companyName"
              placeholder="所属企业"
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.vehicleColdStatus">
            <el-select
              v-model="slotForms.forms.vehicleColdStatus"
              filterable
              clearable
              placeholder="冷配证状态"
            >
              <el-option label="待发证" :value="0"> </el-option>
              <el-option label="已发证" :value="2"> </el-option>
              <el-option label="已作废" :value="1"> </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          min-width="170"
          align="center"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
    <!--导入弹框-->
    <upload-center
      ref="addGoodsFile"
      :visible.sync="dialogImportVisible"
      :initInfo="importParams"
      @update:visible="updateSuccess"
    ></upload-center>
  </div>
</template>

<script>
import {
  FetchVehiclePassCheck,
  saveUpdateColdVehicleInfo,
} from "@/api/report/vehicle";
import { mapActions } from "vuex";
import operationManage from "_private/mixins/operationManage";
import listInit from "@/mixins/listInit";
import { mergeFormExtend } from "_private/utils/merge";
import moment from "moment";
import uploadCenter from "@/components/uploadCenter";

export default {
  mixins: [operationManage, listInit],
  components: { uploadCenter },
  data() {
    return {
      isSearch: false,
      formExtend: {
        forms: {
          bookingDate: moment().format("YYYY"),
          vehicleNum: "",
          companyName: "",
          vehicleColdStatus: "",
        },
        extends: [],
      },
      // 表格列相关
      columSetVisible: false,
      multipleSelection: [],
      // 导入相关
      dialogImportVisible: false,
      importParams: {
        title: "变更冷配证车辆信息",
        templateUrl: "/static/变更冷配证车辆信息模板.xlsx",
        importUrl: "/reserve/vehicle/import",
      },
      //导出URL
      exportUrl: "/reserve/vehicle/export?",
    };
  },
  created() {
    this.setSearchFormIsOpenAct();
    this.initPage();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 请求列表数据
    getTableData() {
      try {
        return new Promise((resolve, reject) => {
          FetchVehiclePassCheck(this.mergeObj())
            .then((response) => {
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize,
      });
    },
    // 重置
    handleResetForm() {
      this.formExtend.forms.bookingDate = moment().format("YYYY"); // 自评年份
    },
    //导出
    handleExportClick() {
      let param = "";
      param += "bookingDate=" + this.formExtend.forms.bookingDate;
      param += "&companyName=" + this.formExtend.forms.companyName;
      param += "&vehicleNum=" + this.formExtend.forms.vehicleNum;
      document.location.href = this.exportUrl + param;
    },
    // 更新冷配车辆信息
    updateColdVehicleInfo() {
      let str = `<div>
                   <p>若车辆符合以下任意情况，系统将删除该车辆的“城市冷链配送车”类型</p>
                   <p>1.不在本年度通行证车辆记录中</p>
                   <p>2.在本年度通行证车辆记录中，<span class="cRed">但“冷配证状态≠已发证”</span></p>
                 </div>`;
      this.$confirm(str, "更新确认", {
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
        dangerouslyUseHTMLString: true,
        customClass: "update-cold-vehicle",
      })
        .then(async () => {
          let res = await saveUpdateColdVehicleInfo();
          if (res.code) {
            this.$message.success("提交成功");
          }

          this.loading = true;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
    /*------------------------------导入-----------------------------------*/
    openImport() {
      this.dialogImportVisible = true;
    },
    updateSuccess(val) {
      if (val) {
        this.dialogImportVisible = false;
        this.getTableData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}
/deep/ .el-table__fixed-body-wrapper {
  height: calc(100% - 36px) !important;
  top: 36px !important;
}
</style>
<style lang="scss">
.update-cold-vehicle {
  width: 530px !important;
  .cRed {
    color: red;
  }
  .el-message-box__status {
    top: 22%;
  }
}
</style>
